var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGrowth(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 492.739 492.739",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91DC5A"
    },
    d: "M246.369,116.773V0l-9.516,5.148c-46.067,24.921-73.57,66.65-73.57,111.625 c0,41.445,23.37,80.123,63.086,105.442V116.773H246.369z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6DC82A"
    },
    d: "M266.369,116.773v105.443c39.717-25.32,63.087-63.997,63.087-105.443 c0-44.975-27.503-86.703-73.57-111.625L246.369,0v116.773H266.369z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00665A"
    },
    d: "M266.369,350.143V222.215V116.773h-20h-20v105.442v127.928c6.594-0.932,13.276-1.41,20-1.41 S259.775,349.212,266.369,350.143z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B39A7C"
    },
    d: "M246.369,348.734c-6.724,0-13.406,0.478-20,1.41c-28.852,4.077-56.008,16.874-77.544,36.676 c-5.478-0.857-11.015-1.289-16.559-1.289c-59.115,0-107.208,48.093-107.208,107.208h221.311V348.734z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A78966"
    },
    d: "M360.473,385.531c-5.545,0-11.081,0.432-16.56,1.289c-21.536-19.802-48.692-32.6-77.544-36.677 c-6.594-0.932-13.276-1.41-20-1.41v144.005h221.312C467.681,433.625,419.587,385.531,360.473,385.531z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrowth);
export default __webpack_public_path__ + "static/media/growth.b866daef182d780f5ebdbc1c964b33e9.svg";
export { ForwardRef as ReactComponent };